import { render, staticRenderFns } from "./BigBgImg.vue?vue&type=template&id=209169d0&scoped=true"
import script from "./BigBgImg.vue?vue&type=script&lang=ts"
export * from "./BigBgImg.vue?vue&type=script&lang=ts"
import style0 from "./BigBgImg.vue?vue&type=style&index=0&id=209169d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209169d0",
  null
  
)

export default component.exports